import React from "react";
import PropTypes from "prop-types";
import { Document16Regular } from "@fluentui/react-icons";
import PdfReferenceIcon from "./icons/PdfReferenceIcon";
import WordReferenceIcon from "./icons/WordReferenceIcon";
import { getReferenceExtension } from "./ReferencesBlock";

const FileTypeIcon = ({ fileName, pdfClassName, wordClassName, defaultClassName }) => {
  const ext = getReferenceExtension({ name: fileName });

  if (ext === "pdf") {
    return <PdfReferenceIcon className={pdfClassName} aria-hidden />;
  }
  if (ext === "docx") {
    return <WordReferenceIcon className={wordClassName} aria-hidden />;
  }

  return <Document16Regular className={defaultClassName} aria-hidden />;
};

FileTypeIcon.propTypes = {
  fileName: PropTypes.string,
  pdfClassName: PropTypes.string,
  wordClassName: PropTypes.string,
  defaultClassName: PropTypes.string,
};

export default FileTypeIcon;
